import React from 'react';
import history from 'history.js';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import API from 'shared/constants/api';
import { bindActionCreators } from 'redux';
import { withFetch } from 'shared/hocs/withFetch';
import { toLocalized } from 'shared/helpers/locale';
import { withTranslate } from 'shared/hocs/withTranslate';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import {
  setOffersData,
  setSelectedValues,
  setInsuranceRegions,
  setIsNumberBlock,
} from 'shared/actions/globals';
import ByParamsForm from './ByParamsForm/ByParamsForm';
import s from './Insurance.css';

class Insurance extends React.Component {
  static propTypes = {
    regions: PropTypes.arrayOf(PropTypes.shape()),
    filters: PropTypes.shape(),
    setOffers: PropTypes.func.isRequired,
    setSelValues: PropTypes.func.isRequired,
    setRegions: PropTypes.func.isRequired,
    //
    fetch: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
  };

  static defaultProps = {
    regions: [],
    filters: null,
  };

  setOffersData = async (offersData, page, selecedValues, isUpdate = false) => {
    const { setOffers, setSelValues, t } = this.props;

    await setOffers(offersData);
    await setSelValues(selecedValues);

    if (!isUpdate) history.push(toLocalized(`/insurance/${page}/`, t('locale')));
  };

  handleRegionChange = async name => {
    const { setRegions, t } = this.props;
    const regions = await fetch(API.POLIS.REGIONS(name, t('locale')))
      .then(res => res.json())
      .then(response => response && response.data);
    setRegions(regions);
  };

  render() {
    const { regions, fetch, t } = this.props;
    const filters = this.props.filters || {
      dgo: {},
      epolils: {},
      is_taxy: {},
      owner_type: {},
      privileges: {},
      region: {},
      transport_type: {},
      validity: {},
    };

    return (
      <div className={s.root}>
        <span className={s.title}>{t('Рассчитать стоимость ОСАГО')}</span>
        <ByParamsForm
          setOffersData={this.setOffersData}
          handleRegionChange={this.handleRegionChange}
          filters={filters}
          regions={regions}
          fetch={fetch}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ globals: { insurance } }) => ({
  regions: insurance.regions,
  filters: insurance.filters,
  selectedValues: insurance.selectedValues || {},
});

const mapDispatchToProps = dispatch => ({
  setOffers: bindActionCreators(setOffersData, dispatch),
  setSelValues: bindActionCreators(setSelectedValues, dispatch),
  setRegions: bindActionCreators(setInsuranceRegions, dispatch),
  setNumberBlock: bindActionCreators(setIsNumberBlock, dispatch),
});

export default withStyles(s)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withFetch(withTranslate(Insurance))),
);



// WEBPACK FOOTER //
// ./src/desktop/routes/home/components/Insurance/Insurance.js